import React from "react";
import styled from "styled-components";
import DropdownMenu from "../DropdownMenu/DropdownMenu";
import MenuItem from "../MenuItem/MenuItem";
import isTouchDevice from "../../@uikit/utils/isTouchDevice";
import { Flex, Box } from "@edricphan2022/uikit";
import { Text } from "@edricphan2022/uikit";
import { MenuItemsProps } from "./types";
import IconComponent from "../Svg/IconComponent";
// import { ChevronDownIcon } from "../Svg";

const MenuItems: React.FC<MenuItemsProps> = ({
  items = [],
  activeItem,
  activeSubItem,
  ...props
}) => {
  return (
    <Flex {...props}>
      {items.map(({ label, items: menuItems = [], href, icon = "" }) => {
        // const statusColor = menuItems?.find((menuItem) => menuItem.status !== undefined);
        const isActive = activeItem === href;
        const linkProps =
          isTouchDevice() && menuItems && menuItems.length > 0 ? {} : { href };
        return (
          <DropdownMenu
            key={`${label}#${href}#${icon}`}
            items={menuItems}
            py={1}
            activeItem={activeSubItem}
          >
            <MenuItem {...linkProps} isActive={isActive}>
              <IconComponent
                iconName={icon}
                color={isActive ? "secondary" : "textSubtle"}
              />
              <TextNav
                as="h1"
                active = {href == window.location.pathname}
              >
                {label}
              </TextNav>
            </MenuItem>
          </DropdownMenu>
        );
      })}
    </Flex>
  );
};

export default MenuItems;

const TextNav = styled(Text)<{active ?: boolean}>`
  position: relative;
  transition: 0.3s ease;
  font-family: ManropeMedium;

  &::after {
    content: "";
    position: absolute;
    width: ${({active})=> active ? '100%' : '0%'};
    height: 2px;
    background-color: #333333;
    left: 0;
    bottom: 0;
    transition: 0.3s ease;
  }

  &:hover {
    ::after {
      width: 100%;
    }
  }
`;
